import { useContext } from 'react';
import { EditorStateContextType } from '../../types';
import { EditorStateContext } from './EditorStateContext';

export default function useDebouncedEditorStateContext() {
  const contextValue = useContext(EditorStateContext);
  if (!contextValue.editorState && !contextValue.setEditorState) {
    throw Error(
      'useDebouncedEditorStateContext requires context to be set higher in component tree.'
    );
  }
  return contextValue as EditorStateContextType;
}
